import React from 'react'
import "../../CSS/Blog/tituloPrincipal.css"



const TituloPrincipal= () => {
  return (
    <div>
        <h3>The Art of Curating a luxuary Perfume Collection: A Symphony of Scents snd Storiestitulo</h3>
    </div>
  )
}

export default TituloPrincipal